import { Gender } from 'config/enums';

export const genderTranslateMap: Record<Gender, string> = {
  [Gender.M]: 'male',
  [Gender.F]: 'female',
  [Gender.U]: 'unspecified',
};
